import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, initializing } = useContext(AuthContext);
  const location = useLocation();

  /*
   * Authentication is still being restored after
   * a browser refresh. Do not redirect yet.
   */
  if (initializing) {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#ffffff",
          color: "#222222",
          fontSize: "16px",
          fontWeight: 500,
        }}
      >
        Loading...
      </div>
    );
  }

  /*
   * Authentication restoration has finished and
   * there is no authenticated user.
   */
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
        }}
      />
    );
  }

  /*
   * User is authenticated.
   * Render the exact route currently in the browser.
   */
  return children;
};

export default ProtectedRoute;


